import React from "react";
import { createRoot } from "react-dom/client";
import { renderToReadableStream } from "react-dom/server";
import { StaticRouter } from "react-router-dom/server";

import AppEntry from "./appEntry";

const getAllStyles = async (renderDelay?: number) => {
    //Render to get stitches themes
    const rootElement = document.getElementById('root');
    if (!rootElement)
        return "";

    const reactRoot = createRoot(rootElement);

    reactRoot.render((
        <StaticRouter location={window.location.pathname}>
            <AppEntry />
        </StaticRouter>
    ));

    //Dumb wait
    if (renderDelay)
        await new Promise((r) => setTimeout(r, renderDelay));

    //Get stylesheets
    let cssRules: CSSRule[] = [];
    if (document.styleSheets[0]) {
        let stitchesStyle = false;
        for (const cssRule of Array.from(document.styleSheets[0].cssRules)) {
            if (cssRule.cssText.startsWith("--sxs")) {
                cssRules.push(cssRule);
                stitchesStyle = true;
            } else if (stitchesStyle) {
                cssRules.push(cssRule);
                stitchesStyle = false;
            }
        }

    }

    return cssRules.reduce((styleText, cssRule) => {
        styleText += cssRule.cssText
        return styleText;
    }, "");
};

//@ts-ignore
window.SSR = async () => {

    const htmlStream = await renderToReadableStream(
        <StaticRouter location={window.location.pathname}>
            <AppEntry />
        </StaticRouter>
    );

    await htmlStream.allReady;

    return {
        htmlStream,
        styles: getAllStyles
    };
};